import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PageHeaderModule } from 'Src/ng2/shared/components/header/page-header/page-header.module';
import { LogOutModule } from 'Src/ng2/shell/log-out/log-out.module';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';
import { OtherToolsLeftNavComponent } from './other-tools-left-nav/other-tools-left-nav.component';
import { OtherToolsResourcesComponent } from './other-tools-resources/other-tools-resources.component';
import { OtherToolsComponent } from './other-tools.component';

@NgModule({
  declarations: [OtherToolsComponent, OtherToolsLeftNavComponent, OtherToolsResourcesComponent],
  imports: [CommonModule, PageHeaderModule, NvDesignLibraryModule, LogOutModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OtherToolsModule {}
